import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_DESTINATIONS_ASYNC = createAsyncTypes(
  'FETCH_DESTINATIONS',
  'Settings/Alerts/Destinations'
)

export const FETCH_DESTINATION_ASYNC = createAsyncTypes(
  'FETCH_DESTINATION',
  'Settings/Alerts/Destinations'
)

export const CREATE_DESTINATION_ASYNC = createAsyncTypes(
  'CREATE_DESTINATION',
  'Settings/Alerts/Destinations'
)

export const UPDATE_DESTINATION_ASYNC = createAsyncTypes(
  'UPDATE_DESTINATION',
  'Settings/Alerts/Destinations'
)

export const DELETE_DESTINATION_ASYNC = createAsyncTypes(
  'DELETE_DESTINATION',
  'Settings/Alerts/Destinations'
)

export const OPEN_DRAWER = 'Settings/Alerts/Destinations/OPEN_DRAWER'
export const CLOSE_DRAWER = 'Settings/Alerts/Destinations/CLOSE_DRAWER'
export const OPEN_REMOVE_CONFIRM = 'Settings/Alerts/Destinations/OPEN_REMOVE_CONFIRM'
export const CLOSE_REMOVE_CONFIRM = 'Settings/Alerts/Destinations/CLOSE_REMOVE_CONFIRM'
export const DEACTIVATE_DESTINATION = 'Settings/Alerts/Destinations/DEACTIVATE_DESTINATION'
export const DEACTIVATE_DESTINATION_LOADING =
  'Settings/Alerts/Destinations/DEACTIVATE_DESTINATION_LOADING'
export const DEACTIVATE_DESTINATION_DONE =
  'Settings/Alerts/Destinations/DEACTIVATE_DESTINATION_DONE'

export const SIEM_PROTOCOL_VALUES = {
  TCP: 1,
  UDP: 2,
  'TLS/SSL': 3,
  Splunk: 5,
  'CrowdStrike NG-SIEM': 6,
  'Generic Webhook (HTTP)': 7,
}

export const SIEM_LOG_FORMAT_VALUES = {
  CEF_ARCSIGHT: 1,
  KEY_VALUE_SPLUNK: 2,
  LEEF_QRADAR: 3,
  RFC3164: 4,
  RFC5424: 5,
  CEF_WITH_PRI: 6,
  SUMOLOGIC: 7,
  CROWDSTRIKE_NG_SIEM: 8,
  GENERIC_WEBHOOK: 9,
}

export const SIEM_LOG_FORMATS = {
  CEF_ARCSIGHT: 'CEF (Arcsight)',
  KEY_VALUE_SPLUNK: 'Key-Value (Splunk)',
  LEEF_QRADAR: 'LEEF (QRadar)',
  RFC3164: 'RFC 3164',
  RFC5424: 'RFC 5424',
  CEF_WITH_PRI: 'CEF with PRI',
  SUMOLOGIC: 'Sumologic',
  CROWDSTRIKE_NG_SIEM: 'CrowdStrike NG-SIEM',
}

export const SIEM_LOG_FORMAT_OPTIONS = Object.keys(SIEM_LOG_FORMATS).map((key) => ({
  label: SIEM_LOG_FORMATS[key],
  value: SIEM_LOG_FORMAT_VALUES[key],
}))

const GENERAL_SIEM_KB_LINK = 'https://support.ironscales.com/hc/en-us/articles/360004775971-SIEM'

export const SIEM_LOG_FORMAT_GRID_OPTIONS = [
  {
    vendorName: 'ArcSight',
    title: SIEM_LOG_FORMATS.CEF_ARCSIGHT,
    value: SIEM_LOG_FORMAT_VALUES.CEF_ARCSIGHT,
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/arc-sight.png`,
    kbLink: GENERAL_SIEM_KB_LINK,
  },
  {
    vendorName: 'Splunk',
    title: SIEM_LOG_FORMATS.KEY_VALUE_SPLUNK,
    value: SIEM_LOG_FORMAT_VALUES.KEY_VALUE_SPLUNK,
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/splunk.png`,
    kbLink:
      'https://support.ironscales.com/hc/en-us/articles/11331273035804-Setting-Up-Splunk-Cloud-HEC-Collector-for-Ironscales-SIEM-Logs',
  },
  {
    vendorName: 'QRadar',
    title: SIEM_LOG_FORMATS.LEEF_QRADAR,
    value: SIEM_LOG_FORMAT_VALUES.LEEF_QRADAR,
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/radar.png`,
    kbLink: GENERAL_SIEM_KB_LINK,
  },
  {
    vendorName: 'Sumo Logic',
    title: SIEM_LOG_FORMATS.SUMOLOGIC,
    value: SIEM_LOG_FORMAT_VALUES.SUMOLOGIC,
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/sumo-logic.png`,
    kbLink: 'https://support.ironscales.com/hc/en-us/articles/6891681132188-Sumologic-Integration',
  },
  {
    vendorName: 'CrowdStrike',
    title: SIEM_LOG_FORMATS.CROWDSTRIKE_NG_SIEM,
    value: SIEM_LOG_FORMAT_VALUES.CROWDSTRIKE_NG_SIEM,
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/crowdstrike.png`,
    kbLink:
      'https://support.ironscales.com/hc/en-us/articles/17727347762716-Setting-Up-CrowdStrike-Falcon-NG-SIEM-for-IRONSCALES-SIEM-Logs',
  },
  {
    vendorName: 'Microsoft Sentinel',
    title: 'Microsoft Sentinel',
    value: 'microsoft-sentinel',
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/sentinel.png`,
    kbLink:
      'https://support.ironscales.com/hc/en-us/articles/6974483781532-Microsoft-Sentinel-Integration',
  },
  {
    vendorName: 'Google Chronicle',
    title: 'Google Chronicle',
    value: 'google-chronicle',
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/chronicle.png`,
    kbLinkOnly: 'https://cloud.google.com/chronicle/docs/soar/marketplace-integrations/ironscales',
  },
  {
    vendorName: 'Palo Alto Cortex',
    title: 'Palo Alto Cortex',
    value: 'palo-alto-cortex',
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/cortex.png`,
    kbLinkOnly:
      'https://support.ironscales.com/hc/en-us/articles/9203669053340-Palo-Alto-Cortex-XSIAM-Integration',
  },
  {
    vendorName: 'Generic Webhook',
    value: SIEM_LOG_FORMAT_VALUES.GENERIC_WEBHOOK,
    title: 'Generic Webhook',
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/webhook.svg`,
    label: 'Generic Webhook',
    kbLink:
      'https://support.ironscales.com/hc/en-us/articles/25625124753820-Generic-Webhook-HTTP-SIEM-Integration',
  },
]

export const SIEM_LOG_FORMAT_GRID_OPTIONS_OTHER = {
  vendorName: 'Other',
  title: 'Other',
  value: 'other',
  logo: `${STATIC_BASE_URL || ''}/static/webapp/images/siem-integrations/other.svg`,
  kbLink: GENERAL_SIEM_KB_LINK,
}

export const CATALOG_GRID_OPTIONS = [
  ...SIEM_LOG_FORMAT_GRID_OPTIONS,
  SIEM_LOG_FORMAT_GRID_OPTIONS_OTHER,
]

export const FORMATS_WITH_ACCESS_TOKEN_NEED = [
  SIEM_LOG_FORMAT_VALUES.RFC3164,
  SIEM_LOG_FORMAT_VALUES.RFC5424,
  SIEM_LOG_FORMAT_VALUES.SUMOLOGIC,
]

export const FORMATS_WITH_LEGACY_CEF_OPTION = [
  SIEM_LOG_FORMAT_VALUES.CEF_ARCSIGHT,
  SIEM_LOG_FORMAT_VALUES.RFC3164,
  SIEM_LOG_FORMAT_VALUES.RFC5424,
  SIEM_LOG_FORMAT_VALUES.CEF_WITH_PRI,
]

export const WEBHOOK_DESTINATION_LOG_FORMAT = SIEM_LOG_FORMAT_VALUES.KEY_VALUE_SPLUNK

export const FIXED_PROTOCOL_BY_LOG_FORMAT = {
  [SIEM_LOG_FORMAT_VALUES.CROWDSTRIKE_NG_SIEM]: SIEM_PROTOCOL_VALUES['CrowdStrike NG-SIEM'],
  [SIEM_LOG_FORMAT_VALUES.GENERIC_WEBHOOK]: SIEM_PROTOCOL_VALUES['Generic Webhook (HTTP)'],
}

export const isGenericWebhookProtocol = (protocol) =>
  protocol === SIEM_PROTOCOL_VALUES['Generic Webhook (HTTP)']

// Named catalog cards with a real backend log_format (excludes string KB-only slots + Other).
const NAMED_LOG_FORMAT_VALUES = new Set(
  SIEM_LOG_FORMAT_GRID_OPTIONS.filter((opt) => typeof opt.value === 'number').map(
    (opt) => opt.value
  )
)

export const findDestinationForGridOption = (destinations, option) => {
  if (option.value === SIEM_LOG_FORMAT_GRID_OPTIONS_OTHER.value) {
    return (
      destinations.find(
        (d) => !isGenericWebhookProtocol(d.protocol) && !NAMED_LOG_FORMAT_VALUES.has(d.logFormat)
      ) || null
    )
  }

  if (option.value === SIEM_LOG_FORMAT_VALUES.GENERIC_WEBHOOK) {
    return destinations.find((d) => isGenericWebhookProtocol(d.protocol)) || null
  }

  if (typeof option.value === 'number') {
    return (
      destinations.find(
        (d) => d.logFormat === option.value && !isGenericWebhookProtocol(d.protocol)
      ) || null
    )
  }

  // String slots (Sentinel / Chronicle / Cortex) — no destinationType yet (IC-50206).
  return null
}

export const getGridOptionForDestination = (destination, slotLogFormat) => {
  if (destination && isGenericWebhookProtocol(destination.protocol)) {
    return SIEM_LOG_FORMAT_GRID_OPTIONS.find(
      (opt) => opt.value === SIEM_LOG_FORMAT_VALUES.GENERIC_WEBHOOK
    )
  }

  if (destination && typeof destination.logFormat === 'number') {
    const byLogFormat = SIEM_LOG_FORMAT_GRID_OPTIONS.find(
      (opt) => typeof opt.value === 'number' && opt.value === destination.logFormat
    )
    if (byLogFormat) return byLogFormat
    return SIEM_LOG_FORMAT_GRID_OPTIONS_OTHER
  }

  return (
    CATALOG_GRID_OPTIONS.find((opt) => opt.value === slotLogFormat) ||
    SIEM_LOG_FORMAT_GRID_OPTIONS_OTHER
  )
}

/** Webhook is always stored as protocol=7 + KEY_VALUE_SPLUNK (2). */
export const normalizeDestinationIdentity = ({ protocol, logFormat }) => {
  if (isGenericWebhookProtocol(protocol)) {
    return { protocol, logFormat: WEBHOOK_DESTINATION_LOG_FORMAT }
  }
  return { protocol, logFormat }
}

const isOtherDestination = ({ protocol, logFormat }) =>
  !isGenericWebhookProtocol(protocol) && !NAMED_LOG_FORMAT_VALUES.has(logFormat)

/**
 * Uniqueness, mirroring how each card claims a destination:
 * - Generic Webhook: one destination with protocol=7 (logFormat forced to 2).
 * - Named cards: one destination per logFormat (protocol ignored, so ArcSight
 *   over TCP and over UDP can't both exist).
 * - Other: a catch-all card, so only one destination with any unnamed logFormat
 *   (RFC 3164, RFC 5424, CEF with PRI, …).
 */
export const findDuplicateDestination = (destinations, candidate, excludeId = null) => {
  const identity = normalizeDestinationIdentity(candidate)
  const { protocol, logFormat } = identity
  if (logFormat == null) return null

  if (isGenericWebhookProtocol(protocol)) {
    return (
      destinations.find((d) => d.id !== excludeId && isGenericWebhookProtocol(d.protocol)) || null
    )
  }

  if (isOtherDestination(identity)) {
    return destinations.find((d) => d.id !== excludeId && isOtherDestination(d)) || null
  }

  return (
    destinations.find(
      (d) =>
        d.id !== excludeId && !isGenericWebhookProtocol(d.protocol) && d.logFormat === logFormat
    ) || null
  )
}

export const getAvailableLogFormatOptions = (
  destinations,
  { excludeId = null, forWebhook = false } = {}
) => {
  if (forWebhook) {
    return SIEM_LOG_FORMAT_OPTIONS.filter((opt) => opt.value === WEBHOOK_DESTINATION_LOG_FORMAT)
  }

  const usedNamedFormats = new Set()
  let hasOther = false

  destinations.forEach((d) => {
    if (d.id === excludeId || isGenericWebhookProtocol(d.protocol)) return
    if (isOtherDestination(d)) {
      hasOther = true
    } else {
      usedNamedFormats.add(d.logFormat)
    }
  })

  return SIEM_LOG_FORMAT_OPTIONS.filter((opt) => {
    if (!NAMED_LOG_FORMAT_VALUES.has(opt.value)) {
      return !hasOther
    }
    return !usedNamedFormats.has(opt.value)
  })
}

export const AUTH_METHODS = {
  NONE: 'None',
  HTTP_HEADER: 'HTTP Header',
}
